import { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AdminLoginInfoContext, FilterContentContainer } from 'pages/Layout';
import { PrimaryButton } from 'components/common/Button';
import styled from "styled-components";
import { decryptAES256, getHappyCallAll, getRecorderList, getUserAndEvents, postHappyCall, sendNvrApi } from 'api/api';
import { User, Events, Recorder, HappyCall, HappyCallTemplate } from 'type/type';
import { Button } from 'antd';
import hubLayout from 'styles/css/hubLayout.module.css';
import VideoQualityButton from './VideoQualityButton';
import dayjs from "dayjs";
import Loading from 'components/common/Loading';
import { eventLabels, formattedDateTime, getCurrentDateTime } from 'pages/utils/commonUtils';
import HappyCallModal, { MessageWithInputs } from 'components/common/HappyCallModal';
import { RiReplay5Fill , RiForward5Fill } from "react-icons/ri";


interface SearchInputType {
  prev_time: string,
  mac: string,
  process_type: string,
  is_send: string,
  event_type: string,
  // name: string,
  // id: string,
  // contract_no: string,
};


export const CommonDivWrap = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 12px;
}`;

export const CommonDiv = styled.div`
  height: 40%;
  border: 1px solid #7d7e7d;
  border-radius: 1rem;
  padding: 1rem;
  &:nth-child(1) {
    height: 60%;
    border: 0;
    border-radius: 0;
    padding: 0;
  }
}`;

export const ChatDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}`;

export const CommonTableWrap = styled.div`
  width: 14%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  font-size: 12px;
  &:nth-child(1) {
    width: 11%;
  }
  &:nth-child(2) {
    width: 35%;
  }
}`;

export const CommonTable = styled.table`
  border-collapse: collapse;
  border: 0;
  th, td {
    min-width: 4rem;
    padding: 0.4rem;
    text-align: center;
  }
  thead {
    font-weight: 600;
    font-family: var(--font-pretendard-bold);
    color: ${prop => prop.theme.tableHeadTextColor};
    position: relative;
    z-index: 4;
    
    tr:nth-child(2) {
      font-weight: 600;
      background-color: #ffffff5c;
    }
  }
  th {
    position: sticky;
    top: 0;
    background-color: ${prop => prop.theme.tableHeadBgColor};
  }
  tbody {
    tr {
      &:hover {
        background-color: ${props => props.theme.tableBodyTrHoverBgColor};
      }
    }
    td {
      border: 1px solid ${prop => prop.theme.tableBorderColor};
      color: ${prop => prop.theme.tableBodyTextColor};
      &:first-child {
        border-left: 0;
      }
      &:last-child {
        border-right: 0;
      }
    }
    &:hover {
        cursor: pointer;
    }
  }
  .userTBody td {
    text-align: left;
  }
`;

export const HappyCallTableWrap = styled.div`
  height: calc(100% - 3.5rem);
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}`;

function HappyCallList() {
  const { adminLoginInfo } = useContext(AdminLoginInfoContext);
  const chatBoxRef = useRef<HTMLDivElement | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [eventList, setEventList] = useState<Events[]>([]);
  const [selectEventList, setSelectEventList] = useState<Events[]>([]);
  const [userList, setUserList] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [selectEvent, setSelectEvent] = useState<Events|null>(null);
  const [selectUser, setSelectUser] = useState<User|null>(null);
  const [happyCallList, setHappyCallList] = useState<HappyCall[]>([]);
  const [eventHappyCallList, setEventHappyCallList] = useState<HappyCall[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedUserIdx, setSelectedUserIdx] = useState<number | null>(null);
  const [selectedEventIdx, setSelectedEventIdx] = useState<number | null>(null);
  const [plus5Min, setPlus5Min] = useState<string>('');

  const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
  const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
  
  /////////////////////////////////////
  const sectionRef = useRef(null);

  async function onRowClick(event: Events) {
    setLoading(true);
    setSelectEvent(event);

    const secondsBtnEls = document.getElementsByClassName('seconds_btn');
    Array.from(secondsBtnEls).forEach((el) => {
      (el as HTMLElement).style.display = 'none';
    });

    const eventHappyCallList: HappyCall[]|[] = happyCallList.filter((happyCall: HappyCall) => happyCall.event_idx === event.idx) ?? [];
    setEventHappyCallList(eventHappyCallList);

    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'none';
    }
  
    // ------------------------------------ (1) 뷰어 초기화
    viewerInit();
    const recorderListRes = await getRecorderList(0, 0, { mac: event.mac, is_copy: false });
    const recorderListData = recorderListRes.data;

    // AI 탐지, 영상
    await viewerShowThumbnail(recorderListData[0], event);
    setLoading(false);
  }

  function viewerInit() {
    // ------------------------------------ (1) 썸네일 초기화
    drawInit('detail_img');

    // ------------------------------------ (2) 영상 초기화
    window.wl_uWebDisConnect();

    const playEl = document.getElementById('play');
    if (playEl) {
      playEl.style.display = 'flex';
    }

    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'none';
    }

    const nvrStatusEl = document.getElementById('nvrStatus');
    if (nvrStatusEl) {
      nvrStatusEl.style.display = 'none';
      nvrStatusEl.innerHTML = ``;
    }
  }

  const siteApi = async (recorder: Recorder, event: Events) => {
    const nvrReqBody = {
      site: {
        site_userId: recorder.id,
        site_password: recorder.password,
        site_ip: recorder.ip,
        site_web_port: recorder.web_port,
        site_uri: '/api/authCmd',
        site_method: 'POST',
      },
      sendData: {
        command: 'getJpegImage',
        data: {
          channel: Number(event.eCh) - 1,
          time: dayjs(event.eDate).add(1, 'second').format('YYYY-MM-DDTHH:mm:ss.000'),
        },
      },
    };
    const thumbNailObj = await sendNvrApi(nvrReqBody);

    if (thumbNailObj.code !== 200) {
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'flex';
        nvrStatusEl.innerHTML = '해당 시간의 녹화영상을 찾을 수 없습니다';
      }
      return {
        thumbNail: null,
      }; // 녹화영상이 없어도 화면에는 표출한다.
    }

    return {
      thumbNail: thumbNailObj.data,
    };
  };

  const viewerShowThumbnail = async (recorder: Recorder, event: Events) => {
    // ------------------------------------ (1) api 호출하기.
    const result = await siteApi(recorder, event);

    // ------------------------------------ (2) 연결 정보 저장.
    const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
    const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
    const connectObj = {
      site_userId: decryptAES256(recorder.id, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV),
      site_password: decryptAES256(recorder.password, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV),
      site_ip: recorder.ip,
      site_port: recorder.tcp_port || '',
      site_ch: String(Number(event.eCh) - 1),
      site_mac: recorder.mac,
      site_webport: recorder.web_port || '',
      log_date: parseInt(dayjs(event.eDate).format('YYYYMMDD'), 10),
      log_time: parseInt(dayjs(event.eDate).format('HHmmss'), 10), // 이벤트 당시 시간
      // log_time: parseInt(dayjs(event.eDate).subtract(10, 'second').format('HHmmss'), 10), // 10초전
      video_quality: viewerObj.connectObj.video_quality,
    };
    
    // console.log(`result.thumbNail`, result.thumbNail);
    if (result.thumbNail !== null) {
      // ------------------------------------ (3) 썸네일 그리기 && AI탐지일 경우 바운딩 박스 그리기
      const detailImgEl = document.getElementById('detail_img');
      if (detailImgEl) {
        detailImgEl.style.display = 'block';
      }
      drawCanvas({
        canvasId: 'detail_img',
        imgSrc: result.thumbNail,
        boxData: null,
        screenId: 'screen',
      });
    
      setViewerObj({
        ...viewerObj,
        viewType: 'thumbnail',
        connectObj,
        thumbnail: result.thumbNail,
      });
    
      // ------------------------------------ (4) 최대/최소 날짜/시간 설정
      const base = dayjs(event.eDate);
      const minus5Min = base.add(-5, 'minute').format('YYYY-MM-DD HH:mm:ss'); // -5분
      const plus5Min = base.add(5, 'minute').format('YYYY-MM-DD HH:mm:ss'); // +5분
      setPlus5Min(plus5Min);
      // const plus3Sec = base.add(3, 'second').format('YYYY-MM-DD HH:mm:ss'); // +3초
      window.wl_playbackMinDatetime(minus5Min);
      window.wl_playbackMaxDatetime(plus5Min);
      window.wl_autoPauseDatetime(plus5Min);
    
      // ------------------------------------ (5) 썸네일이 있으면, 재생시간 작성
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'none';
        nvrStatusEl.innerHTML = `${event.eDate}`;
      }
    }
  };
  useEffect(() => {
    // 전역(window)에 함수 등록
    window.wl_autoPauseCallBack = () => {
      const playEl = document.getElementById('play');
      if (playEl) {
        playEl.style.display = 'flex';
      }

      const pauseEl = document.getElementById('pause');
      if (pauseEl) {
        pauseEl.style.display = 'none';
      }

      setViewerObj({
        ...viewerObj,
        viewType: 'pause',
      });
      window.wl_playbackMaxDatetime(plus5Min);
    };
  }, []);

  const drawCanvas = (data: any) => {
    const { canvasId, imgSrc } = data;
  
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement | null;
    if (!canvas) return;
  
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
  
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
  
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
  
    ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset transform
    ctx.scale(dpr, dpr); // DPR에 따라 스케일
  
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      // 이미지 크기에 맞게 canvas 크기 설정
      canvas.width = img.width;
      canvas.height = img.height;
    
      ctx?.drawImage(img, 0, 0);
    };
  
    img.onerror = () => {
      console.error(`이미지를 로드할 수 없습니다: ${imgSrc}`);
    };
    
    if (imgSrc.includes('json')) {
      img.src = '/image/no-image.png';
    } else {
      img.src = imgSrc || '/image/no-image.png';
    }
  };

  function drawInit(imgId: string) {
    const canvas = document.getElementById(imgId ?? 'detail_img') as HTMLCanvasElement | null;
    if (!canvas) return;
  
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
  
    ctx.clearRect(0, 0, canvas.width, canvas.height); // 기존 이미지 지우기
  }

  // 영상뷰어 관련
  const defaultViewerObj = {
    viewType: 'none', // none / thumbnail / play / pause
    connectObj: {
      video_quality: 0,
      log_date: 0,   // 선택적(Optional)으로 지정 가능
      log_time: 0,
      site_userId: '',
      site_password: '',
      site_ip: '',
      site_port: '',
      site_ch: '',
      site_mac: '',
      site_webport: '',
    },
    thumbnail: null,
  };
  const [viewerObj, setViewerObj] = useState(defaultViewerObj);

  const onChangeVideoQuality = (checked: any) => {
    // console.log(`switch to ${checked}`);
    const video_quality = checked ? 1 : 0;

    let newViewerObj = {
      ...viewerObj,
      connectObj: {
        ...viewerObj.connectObj,
        video_quality,
      },
    };

    // 영상이 재생중이거나, 일시정지중일 경우에 현재 보고있는 시간으로 이동하여 재생한다.
    if (viewerObj.viewType === 'pause' || viewerObj.viewType === 'play') {
      // 현재 뷰어 시간을 알아온다.
      const timeResult = window.wl_uWebLiveGetTime();

      newViewerObj = {
        ...newViewerObj,
        viewType: 'play',
        connectObj: {
          ...newViewerObj.connectObj,
          log_date: parseInt(dayjs(timeResult.data).format('YYYYMMDD'), 10),
          log_time: parseInt(dayjs(timeResult.data).format('HHmmss'), 10),
        },
      };

      window.wl_uWebDisConnect();

      window.wl_viewerPlayBack(newViewerObj.connectObj);

      const playEl = document.getElementById('play');
      if (playEl) {
        playEl.style.display = 'none';
      }

      const pauseEl = document.getElementById('pause');
      if (pauseEl) {
        pauseEl.style.display = 'block';
      }
    }

    setViewerObj(newViewerObj);
  };

  function onPlay() {
    // 웹뷰어가 제일 위에 보이도록 설정.
    const detailImgEl = document.getElementById('detail_img');
    if (detailImgEl) {
      detailImgEl.style.display = 'none';
    }

    if (viewerObj.viewType === 'none') {
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'flex';
        nvrStatusEl.innerHTML = '재생할 이벤트의 영상을 목록에서 선택해 주세요';
      }
      return;
    }
    if (viewerObj.viewType === 'play') {
      return;
    }

    if (viewerObj.viewType === 'thumbnail') {
      drawInit('detail_img');
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'none';
        nvrStatusEl.innerHTML = '';
      }
      window.wl_viewerPlayBack(viewerObj.connectObj);

      const secondsBtnEls = document.getElementsByClassName('seconds_btn');
      Array.from(secondsBtnEls).forEach((el) => {
        (el as HTMLElement).style.display = 'block';
      });
    } else if (viewerObj.viewType === 'pause') {
      window.wl_uWebLiveSetPlay();
    }

    const playEl = document.getElementById('play');
    if (playEl) {
      playEl.style.display = 'none';
    }

    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'flex';
    }

    setViewerObj({
      ...viewerObj,
      viewType: 'play',
    });
  }

  function onPause() {
    // console.log('onPause', viewerObj);

    if (viewerObj.viewType === 'none') {
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'flex';
        nvrStatusEl.innerHTML = '재생할 이벤트의 영상을 목록에서 선택해 주세요';
      }
      return;
    }
    if (viewerObj.viewType === 'pause') {
      return;
    }
    if (viewerObj.viewType === 'thumbnail') {
      window.wl_viewerPlayBack(viewerObj.connectObj);
    }
    if (viewerObj.viewType === 'play') {
      window.wl_uWebLiveSetPause();
    }

    const playEl = document.getElementById('play');
    if (playEl) {
      playEl.style.display = 'flex';
    }

    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'none';
    }

    setViewerObj({
      ...viewerObj,
      viewType: 'pause',
    });
  }

  function onRandomSeek(timeObj: { sec: number; }) {
    // console.log('onRandomSeek', viewerObj);

    window.wl_uWebLiveSetRandomSeek(timeObj);

    const playEl = document.getElementById('play');
    if (playEl) {
      playEl.style.display = 'none';
    }

    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'block';
    }

    setViewerObj({
      ...viewerObj,
      viewType: 'play',
    });
  }

  function onChangeScreenSize() {
    if (viewerObj.viewType === 'none') {
      const nvrStatusEl = document.getElementById('nvrStatus');
      if (nvrStatusEl) {
        nvrStatusEl.style.display = 'flex';
        nvrStatusEl.innerHTML = '재생할 이벤트의 영상을 목록에서 선택해 주세요';
      }
      return;
    }

    const viewerContainer = document.getElementById('viewer_container');

    // TODO TODO header sidebar footer 사이즈를 가져와서 넣기.
    if (viewerContainer) {
      if (viewerContainer.style.position !== 'fixed') {
        viewerContainer.style.position = 'fixed';
        viewerContainer.style.width = `calc(100% - 260px)`;
        viewerContainer.style.height = `calc(100% - 50px - 50px)`;
        viewerContainer.style.marginBottom = '0px';
        viewerContainer.style.top = '0px';
        viewerContainer.style.left = '0px';
        viewerContainer.style.right = '0px';
        viewerContainer.style.bottom = '0px';
        viewerContainer.style.zIndex = '5000';
        viewerContainer.style.top = '50%';
        viewerContainer.style.left = '50%';
        viewerContainer.style.transform = 'translate(-50%, -50%)';
  
        const screenFullEl = document.getElementById('screen_full');
        if (screenFullEl) {
          screenFullEl.style.display = 'none';
        }
        const screenShrinkEl = document.getElementById('screen_shrink');
        if (screenShrinkEl) {
          screenShrinkEl.style.display = 'block';
        }
      } else {
        viewerContainer.style.position = 'static';
        viewerContainer.style.width = `100%`;
        // viewerContainer.style.height = `492px`;
        // viewerContainer.style.height = `342px`;
        viewerContainer.style.height = `calc(100%)`;
        viewerContainer.style.marginBottom = '2px';
        viewerContainer.style.top = '0px';
        viewerContainer.style.left = '0px';
        viewerContainer.style.right = '0px';
        viewerContainer.style.bottom = '0px';
        viewerContainer.style.zIndex = '0';
        viewerContainer.style.transform = 'none';
  
        const screenFullEl = document.getElementById('screen_full');
        if (screenFullEl) {
          screenFullEl.style.display = 'block';
        }
        const screenShrinkEl = document.getElementById('screen_shrink');
        if (screenShrinkEl) {
          screenShrinkEl.style.display = 'none';
        }
      }
    }

    if (viewerObj.viewType === 'thumbnail') {
      const detailImgEl = document.getElementById('detail_img');
      if (detailImgEl) {
        detailImgEl.style.display = 'block';
      }
      drawCanvas({
        canvasId: 'detail_img',
        imgSrc: viewerObj.thumbnail,
        screenId: 'screen',
      });
    }

    // 화면을 resize 해야만 영상 크기가 바뀐다. (뷰어의 동작임.) 따라서 resize 이벤트 강제 실행.
    const resize = new Event('resize');
    window.dispatchEvent(resize);
  }
/////////////////////////////////////

  // 필터obj
  const [searchObj, setSearchObj] = useState<SearchInputType>({
    prev_time: searchParams.get("prev_time") || "12",
    mac: searchParams.get("mac") || "90DA6A",
    process_type: searchParams.get("process_type") || "",
    is_send: searchParams.get("is_send") || "",
    event_type: searchParams.get("event_type") || "",
    // id: searchParams.get("id") || "",
    // name: searchParams.get("name") || "",
    // contract_no: searchParams.get("contract_no") || "",
  });

  // 검색 value 변경
  const handleSearchValue = (e: any) => {
    setLoading(true);
    const { name, value } = e.target;
    setSearchObj(prev => ({
      ...prev,
      [name]: value
    }));
    setLoading(false);
  };

  const getUserAndEventList = async () => {
    // 조회 버튼 클릭 시 모든 
    setMessage('');
    setEventList([]);
    setSelectEvent(null);
    setSelectEventList([]);
    setHappyCallList([]);
    setEventHappyCallList([]);
    setSelectUser(null);
    setUserList([]);

    setLoading(true);
    const { prev_time, mac, process_type, is_send, event_type } = searchObj;
    
    const pauseEl = document.getElementById('pause');
    if (pauseEl) {
      pauseEl.style.display = 'none';
    }
  
    // ------------------------------------ (1) 뷰어 초기화
    viewerInit();
  
    const response = await getUserAndEvents({ mac, prev_time, process_type, event_type });
    if (response.code === 200) {
      setUserList(response.data.userList);

      const happyCallRes = await getHappyCallAll(0, 0);
      if (happyCallRes.code === 200) {
        setHappyCallList(happyCallRes.data);
      }
    
      const updatedEventList = response.data.eventList.map((event: Events) => {
        const hasHappyCall = happyCallRes.data.some((happyCall: HappyCall) => happyCall.event_idx === event.idx);
        return {
          ...event,
          send_happy_call: hasHappyCall,
        };
      });
      
      setEventList(updatedEventList);
      setLoading(false);
    }
  
    setSearchParams({ mac, prev_time, process_type, is_send, event_type });
  };

  const getEventList = async (user: User) => {
    setLoading(true);
    const selectEventList: Events[]|[] = eventList.filter((event: Events) => event.user_id === user.id) ?? [];
    setSelectUser(user);
    setSelectEventList(selectEventList);
    setLoading(false);
  };

  // const sendHappyCall = async (type: string) => {
  //   setLoading(true);
  //   try {
  //     if (!selectUser) return alert('고객을 선택해주세요.');
  //     if (!selectEvent) return alert('이벤트를 선택해주세요.');
  //     if (!message) return alert('메시지를 입력해주세요.');
    
  //     const isSend = window.confirm(`'${type}'에게 SMS를 전송하시겠습니까?`);
  //     if (!isSend) return;
    
  //     const newHappyCall:HappyCall = {
  //       idx: 0,
  //       user_id: selectUser.id,
  //       event_idx: selectEvent.idx,
  //       send_mobile: selectUser.mobile,
  //       send_type: type,
  //       send_message: message,
  //       send_date: getCurrentDateTime(),
  //       send_id: adminLoginInfo.id,
  //     }

  //     const sendHappyCallRes = await postHappyCall(newHappyCall);
  //     if (sendHappyCallRes.code !== 200) {
  //       return alert('전송에 실패했습니다.');
  //     }
  
  //     // 성공 시 서버에서 최신 목록으로 동기화 (선택)
  //     const happyCallListRes = await getHappyCallAll(0, 0);
  //     if (happyCallListRes.code === 200) {
  //       setHappyCallList(happyCallListRes.data);
  //       const updatedEventList = eventList.map((event: Events) => {
  //         const hasHappyCall = happyCallListRes.data.some((happyCall: HappyCall) => happyCall.event_idx === event.idx);
  //         return {
  //           ...event,
  //           send_happy_call: hasHappyCall,
  //         };
  //       });

  //       const selectEventList: Events[]|[] = updatedEventList.filter((event: Events) => event.user_id === selectUser.id) ?? [];
  //       setSelectEventList(selectEventList);
  //       setEventList(updatedEventList);
  //       const eventHappyCallList: HappyCall[]|[] = happyCallListRes.data.filter((happyCall: HappyCall) => happyCall.event_idx === selectEvent.idx) ?? [];
  //       setEventHappyCallList(eventHappyCallList);
  //       alert('전송을 완료했습니다.');
  //     } else {
  //       console.log(happyCallListRes);
  //       alert('전송에 실패했습니다.');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     alert('전송에 실패했습니다.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const happyCallModal = () => {
    if (!selectUser) return alert('고객을 선택해주세요.');
    if (!selectEvent) return alert('이벤트를 선택해주세요.');
    if (!isModalOpen) {
      // 현재 모달이 열려 있지 않을 때만 히스토리 상태 추가
      window.history.pushState({ modalOpen: true }, '');
    }
    setIsModalOpen(true);
  };

  const sendTemplate = async (type: string, playceholder: {}, happyCallTemplate: HappyCallTemplate) => {
    setLoading(true);
    try {
      const isSend = window.confirm(`'${type}'에게 SMS를 전송하시겠습니까?`);
      if (!isSend) return;
    
      const newHappyCall:HappyCall = {
        idx: 0,
        user_id: selectUser!.id,
        event_idx: selectEvent!.idx,
        send_mobile: selectUser!.mobile,
        send_type: type,
        send_message: happyCallTemplate.message,
        send_date: getCurrentDateTime(),
        send_id: adminLoginInfo.id,
        template_idx: happyCallTemplate.idx,
        variable: playceholder,
        table_name: selectEvent?.table_name || "",
      }

      const sendHappyCallRes = await postHappyCall(newHappyCall);
      if (sendHappyCallRes.code !== 200) {
        return alert('전송에 실패했습니다.');
      }
  
      // 성공 시 서버에서 최신 목록으로 동기화 (선택)
      const happyCallListRes = await getHappyCallAll(0, 0);
      if (happyCallListRes.code === 200) {
        setHappyCallList(happyCallListRes.data);
        const updatedEventList = eventList.map((event: Events) => {
          const hasHappyCall = happyCallListRes.data.some((happyCall: HappyCall) => happyCall.event_idx === event.idx);
          return {
            ...event,
            send_happy_call: hasHappyCall,
          };
        });

        const selectEventList: Events[]|[] = updatedEventList.filter((event: Events) => event.user_id === selectUser!.id) ?? [];
        setSelectEventList(selectEventList);
        setEventList(updatedEventList);
        const eventHappyCallList: HappyCall[]|[] = happyCallListRes.data.filter((happyCall: HappyCall) => happyCall.event_idx === selectEvent!.idx) ?? [];
        setEventHappyCallList(eventHappyCallList);
        alert('전송을 완료했습니다.');
      } else {
        console.log(happyCallListRes);
        alert('전송에 실패했습니다.');
      }
    } catch (error) {
      console.log(error);
      alert('전송에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    // ------------------------------------ 뷰어 init
    window.wl_init(() => {
      console.log('Viewer Load End');
      setLoading(false);
    });
  }, []);
  useEffect(() => {
    const chatBox = chatBoxRef.current;
    if (chatBox) {
      chatBox.scrollTo({ top: chatBox.scrollHeight, behavior: 'smooth' });
    }
  }, [eventHappyCallList]);
  return (
    <>
      {loading && <Loading />}
      <FilterContentContainer>
        <div className='flex-row'>
          <label>검색</label>
          <div className='flex-row'>
            <input type="text" name="mac" value={searchObj.mac} placeholder="MAC 입력" onChange={handleSearchValue} style={{ width: "10rem" }} 
              onPaste={(e) => {
                setSearchObj(prev => ({
                  ...prev,
                  mac: e.clipboardData.getData('text')
                }));
              }}/>
            {/* <input type="text" name="id" value={searchObj.id} placeholder="고객 ID 입력" onChange={handleSearchValue} style={{ width: "10rem" }}/>
            <input type="text" name="name" value={searchObj.name} placeholder="고객명 입력" onChange={handleSearchValue} style={{ width: "10rem" }}/>
            <input type="text" name="contract_no" value={searchObj.contract_no} placeholder="계약번호 입력" onChange={handleSearchValue} style={{ width: "10rem" }}/> */}
          </div>
          <div>
            <select name="prev_time" value={searchObj.prev_time} onChange={handleSearchValue}>
              <option value="12">12시간</option>
              <option value="24">24시간</option>
              <option value="48">48시간</option>
            </select>
          </div>
          <div>
            <select name="process_type" value={searchObj.process_type} onChange={handleSearchValue}>
              <option value="">전체 알람</option>
              <option value="Normal">정상 알람</option>
              <option value="Abnormal">오 알람</option>
            </select>
          </div>
          <div>
            <select name="is_send" value={searchObj.is_send} onChange={handleSearchValue}>
              <option value="">전송여부</option>
              <option value="1">전송완료</option>
              <option value="0">미전송</option>
            </select>
          </div>
          <div>
            <select name="event_type" value={searchObj.event_type} onChange={handleSearchValue}>
              <option value="">전체 이벤트 타입</option>
                {Object.entries(eventLabels).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <PrimaryButton type="button" onClick={getUserAndEventList}>조회</PrimaryButton>
      </FilterContentContainer>
      {/* <div>
        검색 결과: <span style={{ fontWeight: "600" }}>{userList.length ?? 0}</span>건
      </div> */}
      <HappyCallTableWrap>
        <CommonTableWrap>
          <CommonTable>
            <thead>
              <tr>
                <th>고객 명단</th>
              </tr>
              <tr>
                <td>고객명(상호명)</td>
              </tr>
            </thead>
            <tbody className='userTBody'>
              {userList.map((user: User, idx: number) => (
                <tr key={`user_${idx}`}
                  onClick={() => {
                    setSelectedUserIdx(idx); // 선택된 인덱스 저장
                    getEventList(user);      // 기존 로직 실행
                  }}
                  style={{
                    backgroundColor: selectedUserIdx === idx ? 'rgb(55 96 146 / 50%)' : '' // 선택된 행만 배경 변경
                  }}
                >
                  <td>{user.name}({`${user.contract?.[0]?.company_name ?? ''}${user.contract && user.contract.length > 1 ? ` 외 ${user.contract.length - 1}` : ''}`})</td>
                </tr>
              ))}
            </tbody>
          </CommonTable>
        </CommonTableWrap>
        <CommonTableWrap>
          <CommonTable>
            <thead>
              <tr>
                <th colSpan={6}>이벤트</th>
              </tr>
              <tr>
                <td>MAC</td>
                <td>MODEL</td>
                <td>발생시간</td>
                <td>이벤트종류(CH)</td>
                <td>정/오 알람</td>
                <td>전송 여부</td>
              </tr>
            </thead>
            <tbody>
              {selectEventList.filter((event: Events) => {
                const isSendMatch =
                  searchObj.is_send === "" ||
                  (searchObj.is_send === "1" && event.send_happy_call) ||
                  (searchObj.is_send === "0" && !event.send_happy_call);

                const prevHour = parseInt(searchObj.prev_time, 10);
                const now = new Date();
                const eventDate = new Date(event.eDate);
                const isWithinPrevTime = now.getTime() - eventDate.getTime() <= prevHour * 60 * 60 * 1000;

                const isProcessTypeMatch =
                  searchObj.process_type === "" || // 비어있으면 전체
                  (searchObj.process_type === "Abnormal" && event.processType === "false_alaram") ||
                  (searchObj.process_type === "Normal" && event.processType !== "false_alaram");
                
                const isEventTypeMatch =
                  searchObj.event_type === "" || // 비어있으면 전체
                  searchObj.event_type === event.eType;

                return isSendMatch && isWithinPrevTime && isProcessTypeMatch && isEventTypeMatch;
              })
              .map((event: Events, idx: number) => (
                <tr key={`event_${idx}`}
                  onClick={() => {
                    setSelectedEventIdx(idx); // 선택된 인덱스 저장
                    onRowClick(event);      // 기존 로직 실행
                  }}
                  style={{
                    backgroundColor: selectedEventIdx === idx ? 'rgb(55 96 146 / 50%)' : '' // 선택된 행만 배경 변경
                  }}
                >
                  <td>{event.mac}</td>
                  <td>{event.recorder_model}</td>
                  <td>{event.eDate}</td>
                  <td>{eventLabels[event.eType] ?? event.eType}({event.eCh}CH)</td>
                  <td>{event.processType === "false_alaram" ? "오 알람" : "정상 알람"}</td>
                  <td>{event.send_happy_call ? "O" : "X"}</td>
                </tr>
              ))}
            </tbody>
          </CommonTable>
        </CommonTableWrap>
        <CommonTableWrap>
          <CommonTable>
            <thead>
              <tr>
                <th colSpan={2}>상세보기</th>
              </tr>
              <tr>
                <td colSpan={2}>이벤트 발생 내용</td>
              </tr>
            </thead>
            <tbody>
              {selectEvent && (
                <>
                  {selectUser && (
                    <>
                      <tr>
                        <td><b>ID</b></td>
                        <td>{selectUser.id}</td>
                      </tr>
                      <tr>
                        <td><b>상호</b></td>
                        <td>{selectEvent.contract?.company_name ?? ''}</td>
                      </tr>
                      <tr>
                        <td><b>이름</b></td>
                        <td>{selectUser.name}</td>
                      </tr>
                      <tr>
                        <td><b>연락처</b></td>
                        <td>{decryptAES256(selectUser.mobile, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV)}</td>
                      </tr>
                      <tr>
                        <td><b>주소</b></td>
                        <td>{`${selectUser.address} ${selectUser.address_detail}`}</td>
                      </tr>
                    </>
                  )}
                  <tr>
                      <td colSpan={2} style={{ textAlign: 'initial' }}>
                        <div>
                          <b>AI 분석 내용</b><br />
                          {selectEvent.analyzeDetail.trim() ? selectEvent.analyzeDetail : '분석 내용이 없습니다.(No Image)'}
                        </div>
                        <br />
                        <div>
                          <b>관제사 분석 내용</b><br />
                          {selectEvent.processDetail.trim() ? selectEvent.processDetail : '분석 내용이 없습니다.'}
                        </div>
                      </td>
                  </tr>
                </>
              )}
            </tbody>
          </CommonTable>
        </CommonTableWrap>
        <CommonDivWrap>
          <CommonDiv>
            {/* 뷰어 */}
            <section
              ref={sectionRef}
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                rowGap: '12px',
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <div
                  id="viewer_container"
                  className="viewer_container"
                  style={{
                    width: '100%',
                    height: '100%',
                    flex: '0 0 auto',
                    marginBottom: '2px',
                  }}
                >
                  {/* 뷰어 전체 영역 */}
                  <div style={{ width: '100%', height: '100%' }}>
                    <div
                      id="viewer_box"
                      style={{
                        position: 'relative',
                        width: '100%',
                        height: 'calc(100% - 56px)',
                        borderTopLeftRadius: '1rem',
                        borderTopRightRadius: '1rem',
                        background: '#F7F7F8',
                        overflow: 'hidden',
                        backgroundColor: '#39383D',
                      }}
                    >
                      {/* qt 로고, status 영역 */}
                      <figure
                        id="qtspinner"
                        style={{
                          overflow: 'visible',
                          position: 'absolute',
                          left: 0,
                          width: '100%',
                          height: '100%',
                          display: 'none',
                          margin: 0,
                        }}
                      >
                        <center style={{  width: '100%', height: '100%', position: 'relative' }}>
                          <div
                            id="qtstatus"
                            style={{
                              top: 0,
                              width: '100%',
                              height: '100%',
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '13px',
                              fontWeight: 500,
                              color: 'white',
                            }}
                          />
                          <noscript>
                            JavaScript is disabled. Please enable JavaScript
                            to use this application.
                          </noscript>
                        </center>
                      </figure>
                      {/* 영상 영역 */}
                      <div id="screen" style={{ position: 'absolute', width: '100%', height: '100%', display: 'block', textAlign: 'center' }} />
                      {/* 썸네일 영역 */}
                      <canvas id="detail_img" style={{ zIndex: 3, position: 'absolute', width: '100%', height: '100%' }} />
                      <div
                        id="nvrStatus"
                        style={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '13px',
                          fontWeight: 500,
                          color: '#ABABB1',
                          position: 'relative',
                          zIndex: 5,
                        }}
                      />
                    </div>

                    <div className="video_panel" style={{ flex: '0 0 56px', background: "#fff" }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 10px' }}>
                        <div style={{ display: 'flex' }}>
                          <Button  type="text"  id="play" className={`${hubLayout.controllers_wrap}`} onClick={onPlay} >
                            <div className={`${hubLayout.controllers} ${hubLayout.controllers_play}`} />
                          </Button>
                          <Button type="text" id="pause" className={`${hubLayout.controllers_wrap}`} onClick={onPause}>
                            <div className={`${hubLayout.controllers} ${hubLayout.controllers_pause}`} />
                          </Button>
                        
                          <Button  type="text" className={`${hubLayout.controllers_wrap} seconds_btn`} style={{ display: 'none' }} onClick={() => onRandomSeek({ sec: -5 })}>
                            <RiReplay5Fill />
                          </Button>
                          <Button type="text" className={`${hubLayout.controllers_wrap} seconds_btn`} style={{ display: 'none' }} onClick={() => onRandomSeek({ sec: 5 })}>
                            <RiForward5Fill />
                          </Button>
                        </div>
                        <div style={{ display: 'flex' }}>
                          <VideoQualityButton
                            viewerQuality={
                              viewerObj?.connectObj?.video_quality
                            }
                            onChangeVideoQuality={(checked: any) => {
                              onChangeVideoQuality(checked);
                            }}
                          />
                          <Button type="text" className={`${hubLayout.controllers_wrap}`}  onClick={onChangeScreenSize}>
                            <div id="screen_full" className={`${hubLayout.controllers} ${hubLayout.controllers_screen_full}`} />
                            <div id="screen_shrink" className={`${hubLayout.controllers} ${hubLayout.controllers_screen_shrink}`} />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </CommonDiv>
          <CommonDiv>
            <ChatDiv>
              <div ref={chatBoxRef} className={`${hubLayout.chat_box}`}>
                {eventHappyCallList.map((happyCall, idx) => (
                  <div key={`${happyCall}_${idx}`} className={`${hubLayout.message_row} ${hubLayout.user}`}>
                    <div className={`${hubLayout.message_bubble}`}>
                      <div className={`${hubLayout.type}`}>{happyCall.send_type}</div>
                      <span>
                        <MessageWithInputs message={happyCall.send_message} /></span>
                      <div className={`${hubLayout.timestamp}`}>{formattedDateTime(happyCall.send_date)}</div>
                    </div>
                  </div>
                ))}
              </div>
              <PrimaryButton type="button" onClick={happyCallModal}>템플릿 전송</PrimaryButton>
              {/* <div style={{ display: "flex", gap: "10px" }}>
                <PrimaryButton type="button" onClick={happyCallModal}>템플릿</PrimaryButton>
                <input type='text' name='message' value={message} onChange={(e) => setMessage(e.target.value)} />
                <PrimaryButton type="button" style={{ width: "180px" }} onClick={() => sendHappyCall('고객')}>고객 전송</PrimaryButton>
                <PrimaryButton type="button" style={{ width: "170px" }} onClick={() => sendHappyCall('119')}>119 전송</PrimaryButton>
                <PrimaryButton type="button" style={{ width: "170px" }} onClick={() => sendHappyCall('112')}>112 전송</PrimaryButton>
              </div> */}
            </ChatDiv>
          </CommonDiv>
        </CommonDivWrap>
        {isModalOpen &&
          <HappyCallModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} onConfirm={sendTemplate} />
        }
      </HappyCallTableWrap>
    </>
  );
}

export default HappyCallList;